<template class="">
  <div class="flex items-center justify-center min-h-screen">
    <div class="bg-white items-center justify-center">
      <div class="space-y-8">
        <div class="space-y-4 mb-8">
          <h2 class="text-3xl font-bold mb-6 text-left text-bodyText">
            Forgot Password
          </h2>
          <p class="text-[14px] w-[411px] text-grayDark">
            Enter your email address below and we’ll send you a code to log in
            and reset your password
          </p>
        </div>
        <form @submit.prevent="forgotPassword">
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">Email</label>
            <input
              v-model="email"
              type="email"
              placeholder="Enter your email address"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
              :disabled="isLoading"
            />
          </div>
          <button
            type="submit"
            class="w-full py-2 px-4 bg-primaryDarkBg hover:bg-primaryDark text-white font-bold rounded disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="isLoading"
          >
            <span v-if="!isLoading">Send Code</span>
            <span v-else>Sending...</span>
          </button>
        </form>
      </div>

      <div>
        <hr class="w-full border-t-[1px] border-grayLight mb-6" />
        <p class="mt-6 text-primaryDark flex justify-between items-center">
          Remember your password?
          <router-link
            to="/login"
            class="text-primaryDark hover:u px-3 py-3 bg-[#EEEEEE] rounded-md"
            >Log In</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>


    

<script>
import apiClient from "@/axios";

export default {
  name: "ForgotPasswordComponent",
  data() {
    return {
      email: "",
      isLoading: false,
    };
  },
  methods: {
    async forgotPassword() {

      if (!this.email) {
        this.$toast.error("Please enter your email address");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.$toast.error("Please enter a valid email address");
        return;
      }

      this.isLoading = true;

      try {
        const response = await apiClient.post("/web/forgot_password", {
          email: this.email,
        });

        if (response.data.status_code === 200) {
          this.$toast.success(response.data.message);
          this.goToResetPassword();
        }
      } catch (error) {
        console.error("Error sending forgot password request:", error);

        if (
          error.response &&
          error.response.data &&
          error.response.data.detail
        ) {
          this.$toast.error(error.response.data.detail);
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$toast.error(error.response.data.message);
        } else {
          this.$toast.error("An error occurred. Please try again later.");
        }
      } finally {
        this.isLoading = false;
      }
    },
    goToResetPassword() {
      this.$router.push({
        name: "ResetPassword",
        query: { email: this.email },
      });
    },
  },
};
</script>
    
    <style scoped>
</style>
    
    